module.exports = __webpack_public_path__ + "static/media/notice.fc51c942.png";